<div class="container-fluid">
    <div class="ModalHeader">
        <h2 mat-dialog-title>Print RFID </h2>
        <div class="headerButton">
            <button class="btn btn-success" type="button" (click)="sendConfirm()" type="button"><i class="fa fa-floppy-o" aria-hidden="true"></i> Confirm </button>
            <button type="button" class="btn btn-warning" matDialogClose (click)="close()"><i class="fa fa-times"
                    aria-hidden="true"></i> Cancel
            </button>
        </div>
    </div>

    <mat-dialog-content>
        <div class="card">
            <div class="card-body">
                <strong> Are you sure you want to print RFID ? </strong>
            </div>
        </div>
    </mat-dialog-content>

</div>